/* Expenses.tsx
    Une page affichant la gestion des dépenses
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les éléments
    Utilise l'API correspondante pour les opérations de données
*/

import { faReceipt } from '@fortawesome/free-solid-svg-icons';
import { ExpensesCrudCard } from 'features/expenses/components/ExpensesCrudCard';
import PageHeader from 'layout/PageHeader';

export const Expenses = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faReceipt}
			title="Dépenses fournisseurs"
			subtitle="Gérez vos dépenses envers vos fournisseurs"
		/>
		<ExpensesCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
